var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { styled } from "./styling";
const UnstyledSurface = React.forwardRef((props, ref) => {
    const { component: Component = "div", elevation } = props, rest = __rest(props, ["component", "elevation"]);
    // Expecting an error here, couldn't get ref to work with typescript
    // @ts-expect-error
    return React.createElement(Component, Object.assign({}, rest, { ref: ref }));
});
export const Surface = styled(UnstyledSurface) `
  ${(props) => props.theme.createSurface(props.elevation)}
  color: ${(props) => props.theme.colors.foreground};
`;
//# sourceMappingURL=Surface.js.map